module.exports = __webpack_public_path__ + "img/news-2.be961bd5.png";